import { DirectoryPhoneNumberDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryPhoneNumber } from "@/ContactDirectory/Models/DirectoryPhoneNumber";

export class DirectoryPhoneNumberMapper {
    public static toDto(phoneNumber: DirectoryPhoneNumber): DirectoryPhoneNumberDto {
        return {
            number: phoneNumber.number,
            countryId: phoneNumber.countryId,
            extension: phoneNumber.extension
        };
    }
}
